"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderableImage = void 0;
/* eslint-disable react/jsx-props-no-spreading */
var react_1 = __importStar(require("react"));
exports.useRenderableImage = function (_a) {
    var image = _a.image, bearer = _a.bearer;
    var _b = __read(react_1.useState(), 2), src = _b[0], setSrc = _b[1];
    var _c = __read(react_1.useState(), 2), error = _c[0], setError = _c[1];
    var _d = __read(react_1.useState(false), 2), loading = _d[0], setLoading = _d[1];
    react_1.default.useEffect(function () {
        try {
            if (image) {
                var headers = {
                    Authorization: bearer,
                    'cache-control': 'force-cache',
                    cache: 'force-cache',
                };
                setLoading(true);
                fetch(image, {
                    cache: 'force-cache',
                    headers: headers,
                    method: 'GET',
                })
                    .then(function (response) { return response.blob(); })
                    .then(function (data) {
                    var source = URL.createObjectURL(data);
                    setLoading(false);
                    setSrc(source);
                })
                    .catch(function (e) {
                    setError(e);
                    setLoading(false);
                });
            }
        }
        catch (e) {
            setError(e);
            setLoading(false);
        }
    }, [image]);
    return {
        src: src,
        error: error,
        loading: loading,
    };
};
//# sourceMappingURL=useRenderableImage.js.map